import { configureStore } from '@reduxjs/toolkit'

import appState from './AppSlice';

// Automatically adds the thunk middleware and the Redux DevTools extension
export default configureStore({
  // Automatically calls `combineReducers`
  reducer: {
    appState: appState
  }
})